import React, { Dispatch, useEffect, useState } from "react";
import { TripForm } from "../trips/form/TripForm";
import { DrawerStateKinds, openTripLibrary, useDrawerState } from "../../features/Drawer/drawerSlice";
import { RiskViewerKind, setWilmaState, useRiskViewerStateKind } from "../../features/riskViewer/riskViewerSlice";
import { DrawerContainer } from "./TripDrawerStyle";
import { AnyAction } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { RouteRequestInputType, routeRequestInputTypeFromJSON } from "../../generated/gpb/api/route";
import {
    ADVISORY_ROUTE_HOVER,
    ADVISORY_ROUTE_TEXT,
    ADVISORY_TEXT,
    CUSTOM_ROUTE_HOVER,
    CUSTOM_ROUTE_TEXT,
    FORECAST_UPDATE_TEXT
} from "../UserVisibleStrings";
import Toggle from "../trips/form/Toggle";

const handleTripLibraryOpen = ( riskViewerStateKind: string, dispatch: Dispatch<AnyAction> ) =>
{
    if ( riskViewerStateKind === RiskViewerKind.SELECTION_STATE )
    {
        dispatch( setWilmaState() );
    }
    dispatch( openTripLibrary() );
};

export default function TripInputDrawer(): JSX.Element
{
    const [ advisory, setAdvisory ] = useState<boolean>( false );
    const drawerState = useDrawerState();
    const dispatch = useDispatch();
    const riskViewerStateKind = useRiskViewerStateKind();
    const drawerStateTrip = drawerState.kind === DrawerStateKinds.Edit ? drawerState.trip : undefined;
    const isForecastUpdate = drawerState.kind === DrawerStateKinds.Edit ? drawerState.isForecastUpdate : false;
    const drawerStateRouteRequestInput = drawerState.kind === DrawerStateKinds.Edit ? drawerState.routeRequestInput : undefined;

    useEffect( () =>
    {
        if ( drawerStateRouteRequestInput !== undefined )
        {
            const requestType =
                typeof drawerStateRouteRequestInput?.requestType === "number"
                    ? drawerStateRouteRequestInput.requestType
                    : routeRequestInputTypeFromJSON( drawerStateRouteRequestInput?.requestType );
            setAdvisory( requestType === RouteRequestInputType.ADVISORY );
        }
    }, [ drawerStateRouteRequestInput ] );

    if (
        ( drawerState.kind === DrawerStateKinds.Edit || drawerState.kind === DrawerStateKinds.TripInput ) &&
        advisory !== null
    )
    {
        const backgroundColor: string = advisory ? "#FFFFFF" : "#FFFFFF";

        const drawerContent = (
            <DrawerContainer backgroundColor = {backgroundColor}>
                <Box display = "flex" flexDirection = "column" alignItems = "center" justifyContent = "flex-start" pt = {2}
                    width = "100%"
                >
                    {!isForecastUpdate && (
                        <Toggle
                            value = {advisory}
                            setValue = {setAdvisory}
                            labelFalse = {CUSTOM_ROUTE_TEXT}
                            tooltipTrue = {CUSTOM_ROUTE_HOVER}
                            labelTrue = {ADVISORY_ROUTE_TEXT}
                            tooltipFalse = {ADVISORY_ROUTE_HOVER}
                        />
                    )}
                    {advisory &&
                    <Box sx = {{ color: "grey", padding: "16px", paddingTop: "0px" }}>
                        {ADVISORY_TEXT}
                    </Box>}
                    {isForecastUpdate &&
                    <Box sx = {{ color: "grey", padding: "16px", paddingTop: "0px" }}>
                        {FORECAST_UPDATE_TEXT}
                    </Box>}
                    <TripForm
                        defaultValues = {drawerStateTrip}
                        isForecastUpdate = {isForecastUpdate}
                        routeRequestInput = {drawerStateRouteRequestInput}
                        isAdvisory = {advisory}
                        onCancel = {() => handleTripLibraryOpen( riskViewerStateKind, dispatch )}
                        onSubmit = {() => handleTripLibraryOpen( riskViewerStateKind, dispatch )}
                        backgroundColor = {backgroundColor}
                    />
                </Box>
            </DrawerContainer>
        );
        return (
            <Box sx = {{ width: "100%" }}>
                {drawerContent}
            </Box>
        );
    }

    return <DrawerContainer backgroundColor = "white"/>;
}
